import { type NotificationConditionTypeEnumEnum } from '@/shared/api'

export const NotificationConditionTypeEnum = {
  Instant: 1 as NotificationConditionTypeEnumEnum,
  AtTime: 2 as NotificationConditionTypeEnumEnum,
} as const

export type NotificationConditionTypeEnum =
  (typeof NotificationConditionTypeEnum)[keyof typeof NotificationConditionTypeEnum]

export const notificationConditionTypeArray = Object.values(
  NotificationConditionTypeEnum,
)

export const getNotificationConditionTypeString = (
  type: NotificationConditionTypeEnum,
) => {
  switch (type) {
    case NotificationConditionTypeEnum.Instant:
      return 'Моментально'
    case NotificationConditionTypeEnum.AtTime:
      return 'В указанное время'
    default:
      return 'Неизвестный тип'
  }
}
